<template>
  <div class="w-full pb-6">
    <div class="flex justify-content-end mb-4 md:px-4">
      <div class="flex align-items-center gap-2">
        <label class="font-medium text-center">Sort By:</label>
        <Select v-model="selectedSort" :options="sortOptions" optionLabel="label" optionValue="value"
          placeholder="Select" class="w-36" />
      </div>
    </div>

    <div class="grid-container md:px-4">
      <div v-for="(result, index) in results" :key="index">
        <Card class="Card p-4 h-full">
          <template #content>
            <div class="flex flex-column align-items-center justify-content-center gap-2 text-sm">
              <div class="flex justify-content-between align-items-start w-full" style="min-height: 2.5em;">
                <span class="Paragraph-Medium text-center flex-1 truncate-text">{{ result.subject }}</span>
                <span class="Paragraph-Medium text-right">{{ computedGrade(result.marks) }}</span>
              </div>
              <div class="flex flex-column justify-content-center">
                <span class="text-center marks flex align-items-baseline justify-content-center whitespace-nowrap">
                  {{ result.marks }} <span class="Paragraph-Medium ml-2">Marks</span>
                </span>
                <span class="text-center Label truncate-text" style="min-height: 2.5em;">{{ result.examName }}</span>
                <span class="text-center Label">{{ formatToDisplayDate(result.date) }}</span>
              </div>
            </div>
          </template>
          <template #footer>
            <div class="flex justify-content-center gap-2 mt-3">
              <Button label="View Feedback" class="orange-button-small" @click="$emit('view-feedback', result)" />
            </div>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script setup>
import Card from "primevue/card";
import Button from "primevue/button";
import { defineProps, defineEmits } from "vue";
import { ref } from 'vue';
import Select from 'primevue/select';
import { computedGrade, formatToDisplayDate } from "@/utils/cleanups";
defineProps({
  results: {
    type: Array,
    required: true
  }
});
const selectedSort = ref(null);
const sortOptions = [
  { label: 'Newest', value: 'newest' },
  { label: 'Oldest', value: 'oldest' },
];
defineEmits(['view-feedback']);
</script>
<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
  gap: 3rem;
}

.Card {
  /* background-color: var(--teal-800); */
  border-radius: 4px;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.16);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.teal-button {
  padding: 8px 16px 8px 16px;
  height: 30px;
  font-size: 0.75rem;
}

.p-button-danger {
  padding: 10px 16px 10px 16px;
  height: 30px;
}

.marks {
  font-size: 112px;
  font-weight: 700;
  font-family: 'Raleway', sans-serif;
  line-height: 110%;
  color: var(--black-500);
}

.truncate-text {
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>